
import SetCropsModal from "@/components/Modals/SetCropsModal.vue";
import { Component, MixedVue, mixins } from "@/vue";
import { propsInstance } from "@/lib/util";

const Props = propsInstance<{
  parcelIds: string[];
}>({
  parcelIds: { type: Array, required: true },
});

@Component({
  name: "SetCropsButton",
  components: { SetCropsModal },
})
export default class SetCropsButton extends mixins(MixedVue, Props) {
  static components: {
    SetCropsModal: typeof SetCropsModal;
  };

  showModal = false;
}
